import {css, html, LitElement, nothing, PropertyValues} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('ents-wishlist-product-image-overlay')
export class ProductImageOverlay extends LitElement {
  @property({type: Boolean, attribute: 'is-beauty', reflect: true})
  private isBeauty: boolean = false;

  @property({type: String, attribute: 'brand-code', reflect: true})
  private brandCode: string = '';

  @property({type: Boolean, reflect: true})
  private visible: boolean = false;

  static readonly styles = css`
    :host([visible]) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      display: flex;
      align-items: stretch;
      justify-content: stretch;
    }
  `;

  protected update(changedProperties: PropertyValues) {
    super.update(changedProperties);

    this.visible = this.shouldDisplayOverlay();
  }

  private shouldDisplayOverlay(): boolean {
    return this.isBeauty && !['291', 'c33', '15v'].includes(this.brandCode.toLowerCase());
  }

  protected render(): unknown {
    if (this.visible) {
      return html`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 286 391" fill="none"
             class="ents-wishlist-product-image-overlay">
          <path fill="url(#a)" fill-opacity=".07" d="M0 0h286v391H0z"/>
          <defs>
            <radialGradient id="a" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
              <stop offset="0%" stop-color="#fff"/>
              <stop offset="20%" stop-color="#fff"/>
              <stop offset="100%" stop-color="#905207"/>
            </radialGradient>
          </defs>
        </svg>`;
    } else {
      return nothing;
    }
  }
}
